<template>
		<div class="content">
      <Header></Header>
      <div class="personal-info daily-login">
        <div class="mission-content" style="width: 90%;">
          <DailyLogin message="2"></DailyLogin>
        </div>
      </div>
		</div>
</template>
<script>
import Header from '../components/header'
import DailyLogin from '../components/dailyLogin'
export default {
  components:{
    Header,DailyLogin
  },
  data() {
    return {
      info:{},
      dailyList:[]
    }
  },
	created(){

	},
  methods: {
		back(){
			this.$router.push({path:'/'})
		},
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/dailyLogin.vue